<script lang="ts" setup>
import { definePage } from "vue-router/auto";

definePage({
	meta: {
		requiresAuth: true,
		featureFlag: "store-management",
	},
	redirect: "/store/configuration",
});
</script>
